//
import Button from "./Button"

// ----------------------------------------------------------------------

export default function ComponentsOverrides() {
  return Object.assign(Button())
}
